export default "__VITE_ASSET__DOv_td1K__"